import { PrinterPosNetworkIcon } from './PrinterPosNetworkIcon';

/**
 * author: Colton Wiscombe
 * id B91F589E-8733-47ED-8B29-7D1BBCFBC98F
 * name printer-pos-network
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-network.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleNetworkIcon = PrinterPosNetworkIcon;
export default PrinterPointOfSaleNetworkIcon